module.exports = __webpack_public_path__ + "assets/images/animations/unleash-animation.png?fc79d600";